import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { PartnerContactInfo } from '../fragments';

export default gql`
  mutation updatePartnerContact($input: PartnerContactUpdateInput!) {
    updatePartnerContact(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      partnerContact {
        ...PartnerContactInfo
      }
    }
  }
  ${PartnerContactInfo}
  ${ErrorMessageInfo}
`;
